import { getRoute } from "../client"
import type { RoomDto } from "../../shared/types"
export const roomsListRoute = getRoute<RoomDto[]>("/api/rooms")
